import {
  type CheckoutSessionResponse,
  getCheckoutSession,
  isIdentifiedCustomer,
} from 'api/checkout';
import { useCommonStore } from 'stores/common';
import { Gtm, type Session } from 'tracking';

export const initialSessionPromise =
  typeof window !== 'undefined'
    ? getCheckoutSession().catch(() => undefined)
    : Promise.resolve(undefined);

export const mapCheckoutSessionToGtmSession = (data: CheckoutSessionResponse): Session => {
  const { clientIpv6 } = useCommonStore.getState();

  return {
    //customerEmail etc will also be set by setCustomer, but be careful, the very first gtm push for sessions needs to have as well all data available
    clientIp: data.clientIp,
    ...(clientIpv6 && { clientIpv6 }),
    landingPageUrl: data.landingPageUrl,
    ...(isIdentifiedCustomer(data)
      ? {
          customerId: data.customerId,
          customerEmail: data.email,
          ...(data?.firstName ? { customerFirstName: data?.firstName } : {}),
          ...(data?.lastName && { customerLastName: data?.lastName }),
          ...(data?.phone && { customerPhone: data?.phone }),
          ...(data?.postcode && { customerPostcode: data?.postcode }),
          ...(data?.street && { customerStreet: data?.street }),
          ...(data?.city && { customerCity: data?.city }),
          ...(data?.countryCode && {
            customerCountry: data?.countryCode,
          }),
          customerOrdersCount: data.ordersCount,
          customerSubscriptionStatus: data.subscriptionStatus,
        }
      : {}),
  };
};

// We want to set session data as soon as possible, so we do it outside of React lifecycle for initial load
initialSessionPromise.then((data) => {
  if (data) {
    Gtm.session(mapCheckoutSessionToGtmSession(data));
  }
});
